import { TextProps } from "../../types/textTypes";
import "./h4.scss";

const H4: React.FC<TextProps> = ({ children, className }) => {
  return <h3 className={`h4 ${className ? className : ""}`}>{children}</h3>;
};

export default H4;
